<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <model-edit
          class="col-12"
          :loading="loading"
          :updating="updating"
          :deleting="deleting"
          v-bind="$props"
          v-model="model"
          :errors.sync="errors"
          :key="getModelKey()"
          @back-click="handleBack"
          @update-click="handleUpdate"
          @delete-click="handleDelete"
          @model-changed="handleModelChanged"
      >
      </model-edit>
    </div>
    <UserApproverBlockedModal ref="warningModal" />
  </Layout>
</template>

<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/user";
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import UserApproverBlockedModal from "@/components/modals/user-approver-blocked-modal.vue";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit JALA Trade Users",
  },
  components: {
    Layout,
    PageHeader,
    UserApproverBlockedModal,
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('users.singular')) }},
    resourceRoute: {default: 'users'},
    modelVariable: {default: 'user'},
    form: {default() { return FormsModel; }},
    denyDelete: {type: Boolean, default: true}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('users.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('users.plural')),
          href: "/users",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/users/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/users/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    getModelName() {
      return this.model.name || this.getModelKey();
    },
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/users/${this.$route.params.key}`, {
        params: { with: 'user' }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      return this.$axios.put(`/users/${this.$route.params.key}`, {
        ...value,
      })
    },
    handleUpdate(value) {
      this.updating = true;
      this.update(value)
        .then(() => this.updateSuccessAlert(this.getModelName()))
        .then(() => {
          this.isEditing = false;
          return this.$router.back()
        })
        .catch((error) => {
          if (error.response && error.response.status === 422 && error.response.data.errors && error.response.data.errors.is_bound_to_approval) {
            this.$refs.warningModal.show({ name: this.model.name });
          } else {
            this.failedAlert(error);
          }
        })
        .finally(() => { this.updating = false; });
    },
    delete() {
      return this.$axios.delete(`/users/${this.$route.params.key}`)
    }
  }
}
</script>
